module.exports = __webpack_public_path__ + "static/img/5-4.985e7a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-4.png
// module id = 275
// module chunks = 0